import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HsgRouteGuardService } from '@hhsg/hsg-asc';

import { CostCenterComponent } from './cost-center/cost-center.component';
import { StaffingComponent } from './staffing.component';
import { WorkforceRouteGuardService } from '../../workforce-route-guard.service';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path: '',
				component: StaffingComponent,
                children: [
                    { path: 'cost-center', component: CostCenterComponent, canActivate: [HsgRouteGuardService, WorkforceRouteGuardService] },
                ]
			}
		])
	],
	exports: [RouterModule]
})
export class StaffingRoutingModule {
}
